<div class="row row-sm add-form min">
    <div class="col-lg-12 ">
      <div class="card-body">
        <div class="bc d-flex align-items-center pl-3">
          <div class="ml-2">
            <h3 class="main-content-label mb-1"><b>
                Subjects Appeared
              </b></h3>
          </div>
        </div>
       
        <div class="row row-sm add-form">
            <!-- <h6>{{data.data.ReRgId}}   {{data.data.RgName}}</h6> -->
            <div class="col-sm-12 pl-0 mt-3">
                <div>
                    <div class="table-responsive table-container" id="table">
                        <table class="table table-bordered text-nowrap">
                            <thead>
                                <tr class="text-left">
                                    <th class="f600">
                                        Ty
                                    </th>
                                    <th class="f600">
                                        Sub
                                    </th>
                                    <th class="f600">
                                        Head
                                    </th>
                                    <th class="f600">
                                        MaxMarks
                                    </th>
                                    <th class="f600">
                                        Marks
                                    </th>
                                    <th class="f600">
                                        Grade
                                    </th>
                                    <th class="f600">
                                        Result
                                    </th>
                                    <th class="f600">
                                        Dist
                                    </th>
                                    <th class="f600">
                                        GP
                                    </th>
                                    <th class="f600">
                                        GP_CR
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="curs">
                                <!-- {{log(subGrid)}} -->
                                <tr *ngFor="let item of subGrid">
                                    <td>{{item.EsType}}</td>
                                    <td>{{item.SubCode}}</td>
                                    <td>{{item.HdCode}}</td>
                                    <td>{{item.FsMaxMarks}}</td>
                                    <td>{{item.Marks}}</td>
                                    <td>{{item.FsGrade}}</td>
                                    <td>{{item.FsResult}}</td>
                                    <td>{{item.FsDistSign}}</td>
                                    <td>{{item.FsGrdPts}}</td>
                                    <td>{{item.FsGP_CR}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
          <!-- <button type="button" [mat-dialog-close]="true"
            class="btn fr sz btn-primary btn-icon-text floatright mr-3 mt-1">
            <span style="display: contents; align-items: center; margin-left:1rem;">
              <img width="20vh" src="../../assets/img/list.gif" style="margin-right: 7px;">
              List
            </span>
          </button> -->
          <div class="col-sm-12 ">
            <button type="button" [mat-dialog-close]="true"
            class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
              <span style="display: contents; align-items: center;">
                <img width="15vh" src="../../assets/img/list.gif" style="margin-right: 7px;">
                List
              </span>
            </button>

            <!-- <button type="button" (click)="download()"
            class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
              <span style="display: contents; align-items: center;">
                <img width="15vh" src="../../assets/images/arrow (1).png" style="margin-right: 7px;">
               Download
              </span>
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>